module.exports = __webpack_public_path__ + "img/xp.046a5e6e.svg";